import { createSlice } from "@reduxjs/toolkit";
import {
  createInvestmentThunk,
  getInvestmentsThunk,
  getSingleInvestmentThunk,
  updateInvestmentThunk,
  deleteInvestmentThunk,
  deleteTransactionThunk,
} from "./investment.thunk";

const initialState = {
  investments: [],
  singleInvestment: null,
  loading: false,
  error: null,
};

const investmentSlice = createSlice({
  name: "investment",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(createInvestmentThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createInvestmentThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.investments.push(action.payload.data);
      })
      .addCase(createInvestmentThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getInvestmentsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInvestmentsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.investments = action.payload.data;
      })
      .addCase(getInvestmentsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getSingleInvestmentThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSingleInvestmentThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleInvestment = action.payload.data;
      })
      .addCase(getSingleInvestmentThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateInvestmentThunk.fulfilled, (state, action) => {
        const updated = action.payload.data;

        state.investments = state.investments.map((inv) =>
          inv._id === updated._id ? updated : inv
        );

        if (state.singleInvestment?._id === updated._id) {
          state.singleInvestment = updated;
        }
      })

      .addCase(deleteInvestmentThunk.fulfilled, (state, action) => {
        state.investments = state.investments.filter(
          (inv) => inv._id !== action.payload.id
        );
      })

      .addCase(deleteTransactionThunk.fulfilled, (state, action) => {
        const updatedInvestment = action.payload.data;

        state.investments = state.investments.map((inv) =>
          inv._id === updatedInvestment._id ? updatedInvestment : inv
        );

        if (state.singleInvestment?._id === updatedInvestment._id) {
          state.singleInvestment = updatedInvestment;
        }
      });
  },
});

export default investmentSlice.reducer;